module.exports = __webpack_public_path__ + "static/bnr_square@3x-ca416a5c42d6736c934365c86c920753.png";